import { Box, ButtonNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useEffect, useRef, useState, useTransition } from 'react'
import { FlatList, ScrollView } from 'react-native'
import { Routes } from '../../nav/routes'
import { formatDateRange, getWeekRanges, roundOfToTwoDigits } from '../../util/util'
import { ShimmerView } from '../ShimmerView'
import { TableComponent } from '../TableComponent'
import { Header } from './Header'

export const ListWithDateRange = ({
  data,
  handleItemPress,
  canFetchMoreTxns,
  isMaxDateRangeSelected,
  path,
  refreshControl,
  isSeeAllVisible,
  onListFooterPress,
  listEmptyComponent,
  hide,
  showShimmerView,
  loadMoreErrorState,
  newDataFetch = false,
  layoutRef,
}: any) => {
  const [listHeaderOffset, setListHeaderOffset] = useState([])
  const [listData, setListData] = useState([])
  const scrollRef = useRef(null)
  const getDataWithDateRange = () => {
    let headers = []
    const retData = []
    if (path === Routes.SETTLEMENTS) {
      headers = getWeekRanges(data)
    } else {
      data?.map((item: any) => {
        const date = item?.timestamp
        headers.indexOf(date) === -1 && headers.push(date)
      })
    }

    headers?.map((item, index) => {
      const eachDayRecords = path !== Routes.SETTLEMENTS ? data?.filter((obj) => obj.timestamp === item) : []
      const eachWeekRecords =
        path === Routes.SETTLEMENTS ? data?.filter((obj) => obj.timestamp <= item?.h && obj.timestamp >= item?.l) : []

      const records = path === Routes.SETTLEMENTS ? eachWeekRecords : eachDayRecords

      records?.length > 0 &&
        retData.push({
          header: path === Routes.SETTLEMENTS ? formatDateRange(item?.l, item?.h) : item,
          records: path === Routes.SETTLEMENTS ? eachWeekRecords : eachDayRecords,
        })
    })
    const listHeaderOffsetArrTemp = []

    retData?.map((item, index) => {
      if (index === 0) {
        if (listHeaderOffsetArrTemp?.length === index) {
          listHeaderOffsetArrTemp.push(0)
        }
      } else {
        const prevOffset = listHeaderOffsetArrTemp[index - 1]
        const headerHeight = 32
        const prevSectionHeight = retData?.[index - 1]?.records?.length * 68
        const offset = prevOffset + headerHeight + prevSectionHeight
        listHeaderOffsetArrTemp?.length === index && listHeaderOffsetArrTemp.push(offset)
      }
    })
    // set header title when new data is available
    const dataRef = { ...layoutRef?.current }
    // ofset y set to be 1 from props
    if (dataRef?.y === 1) {
      startTransition(() => {
        setListHeaderTitle(retData?.[0]?.header)
      })
    }
    setListData(retData)
    setListHeaderOffset(listHeaderOffsetArrTemp)
    return { data: retData, headerOffset: listHeaderOffsetArrTemp }
  }
  const [isPending, startTransition] = useTransition()

  useEffect(() => {
    getDataWithDateRange()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  const [listHeaderTitle, setListHeaderTitle] = useState('')

  if (hide) {
    return null
  }
  const onScroll = (evt: any) => {
    const layout = evt?.nativeEvent?.contentOffset
    if (layoutRef) {
      layoutRef.current = layout
    }
    const filterdListHeaderOffset = listHeaderOffset?.filter((item) => layout?.y >= item)
    const currentListHeaderOffset = filterdListHeaderOffset?.[filterdListHeaderOffset?.length - 1]
    const currentListHeaderOffsetIndex = listHeaderOffset.indexOf(currentListHeaderOffset)
    if (currentListHeaderOffset > -1) {
      startTransition(() => {
        setListHeaderTitle(listData?.[currentListHeaderOffsetIndex]?.header)
      })
    }
  }

  const handleViewMorePress = () => {
    onListFooterPress()
  }
  const renderListFooterComponent = () => {
    if ((data?.length > 1 && isSeeAllVisible) ?? false) {
      return (
        <ModBox
          show={(data?.length > 1 && isSeeAllVisible) ?? false}
          onPress={onListFooterPress}
          testID="view-all-txn"
          underlayColor="WHITE"
          pv={4}
          ph={24}>
          <Text type="h3Bold" color={'BLUE'}>
            {'View All Transactions'}
          </Text>
        </ModBox>
      )
    }
    if (loadMoreErrorState) {
      return (
        <Box p={32} justify={'center'} align={'center'}>
          <Text
            title={'Something went wrong'}
            fontFamily={'JioType-Bold'}
            fontSize={14}
            lineHeight={20}
            letterSpacing={-0.08}
          />
          <Spacer direction="vertical" size={8} />
          <Text
            title={'Try Again'}
            fontFamily={'JioType-Medium'}
            fontSize={14}
            lineHeight={20}
            letterSpacing={-0.08}
            fontWeight={'600'}
            color={'PRIMARY'}
            testID="try-again"
            onPress={() => onListFooterPress(true)}
          />
        </Box>
      )
    }
    if (data?.length > 0 && !isSeeAllVisible && (canFetchMoreTxns || !isMaxDateRangeSelected) && !showShimmerView) {
      return (
        <Box pv={24} align={'center'} alignSelf={'center'}>
          <ButtonNew
            title={'Show more'}
            onPress={handleViewMorePress}
            testID="view-more-btn"
            type={'secondary'}
            underlayColor="TRANSPARENT"
            titleColor={'PRIMARY'}
            paddingHorizontal={24}
            paddingVertical={8}
            borderColor={'PRIMARY'}
            isRaceTrack
          />
        </Box>
      )
    }

    if (showShimmerView) {
      return <ShimmerView type={path} itemCount={2} />
    }
    return <Box h={80} />
  }

  const headerType = (dateVal: string) => {
    const today: Date = new Date(Date.now())
    const todayDay = today.getDate()
    const todayMonth = today.getMonth() + 1
    const todayYear = today.getFullYear()
    if (`${roundOfToTwoDigits(todayDay)}-${roundOfToTwoDigits(todayMonth)}-${todayYear}` === dateVal) {
      return 'Today'
    } else {
      const yesterday = new Date(today.setDate(todayDay - 1))
      const yesterDate = yesterday.getDate()
      const yesterMonth = yesterday.getMonth() + 1
      const yesterYear = yesterday.getFullYear()

      if (`${roundOfToTwoDigits(yesterDate)}-${roundOfToTwoDigits(yesterMonth)}-${yesterYear}` === dateVal) {
        return 'Yesterday'
      } else {
        return ''
      }
    }
  }

  if (listData?.length === 0) {
    return listEmptyComponent()
  }
  return (
    <>
      <Header
        show={listData?.length > 0}
        dateVal={!isEmpty(listHeaderTitle) ? listHeaderTitle : listData?.[0]?.header}
        type={headerType(listHeaderTitle)}
        path={path}
      />

      <ScrollView ref={scrollRef} onScroll={onScroll} scrollEventThrottle={16} refreshControl={refreshControl}>
        <FlatList
          data={listData}
          ListFooterComponent={renderListFooterComponent}
          ListEmptyComponent={listEmptyComponent}
          renderItem={({ item, index }) => (
            <>
              <Header
                show={!isEmpty(item?.header) && index > 0}
                dateVal={item?.header}
                type={headerType(item?.header)}
                path={path}
              />
              <TableComponent customOnPress={handleItemPress} ListContent={item?.records} value={path} />
            </>
          )}
        />
      </ScrollView>
    </>
  )
}
